import { render, staticRenderFns } from "./Posta.vue?vue&type=template&id=9d82f0e8&scoped=true&"
import script from "./Posta.vue?vue&type=script&lang=js&"
export * from "./Posta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d82f0e8",
  null
  
)

export default component.exports